import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { QrcodePage } from './qrcode';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [
	QrcodePage,
	],
	imports: [
	TranslateModule,
	IonicPageModule.forChild(QrcodePage),
	],
})
export class QrcodePageModule {}



// WEBPACK FOOTER //
// ./src/pages/qrcode/qrcode.module.ts